// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> dolben-rise -> the-view-at-mill-run
// Generated: 2026-11-03T15:48:09.993Z
// Counts: 0 design, 63 content, 7 slot group, 2 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The View at Mill Run is ideally situated, with easy access to the Owings Mills Metro Station, I-795, I-83, and I-695. Whether it's the changing seasons, bird watching, or deer sightings, there is something for everyone to enjoy. Our apartments Owings Mills, MD offer a variety of shopping, dining and entertainment options. Our apartment community is perfect for people wanting to enjoy the suburban life: lounge by our resort-style pool, or hike through Soldier's Delight, a natural environment area with over 1,900 acres, offering beautiful vistas and hiking trails. You can strengthen your body and soothe your soul at our state-of-the-art 24-hour fitness and yoga room. Our <a class=\"richtext-link\" href=\"/floor-plans\">one- and two-bedroom floor plans</a> provide ample space, designer finishes, and fully applianced kitchens, making entertaining a breeze. On top of that, our apartments have outdoor patios, an easy place for you to relax and take a load off. You can see for yourself how much we pride the look of our community by viewing the photos of the apartments. Our pet-friendly community offers many choices that are sure to accommodate your lifestyle, including loft options. Extraordinary defines The View at Mill Run, a community that has everything to meet your lifestyle needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Spaces and features designed for everyday living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "communityfilmembed.video": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/property/6737460151193209/01a1210f-00af-7083-b722-80ca9059b1af.m4v",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reach our leasing team — we're happy to help</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Let's Talk</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.call_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>CALL US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>OFFICE HOURS</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactinfocards.visit_label": {
    "overrideType": "VALUE",
    "customValue": "<h3>VISIT US</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find a layout that fits your life</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>A look inside our apartments and community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Luxury Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Now Leasing</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "lifestyleintro.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>A LIFESTYLE DESIGNED FOR YOU</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover local favorites just around the corner</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhooddiscover.headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>DISCOVER THE NEIGHBORHOOD</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "By submitting this form and signing up for texts, you consent to receive text messages (including review requests and/or surveys) about your experience at the phone number you provided. Message & data rates may apply. Message frequency varies. Unsubscribe at any time by replying STOP. Reply HELP for help.",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_enabled": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience The Dolben Difference</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>What People Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "terms-and-conditions-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Terms &amp; Conditions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore our homes from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There's more to love at The View at Mill Run; The View at Mill Run overlooks Soldier's Delight Natural Environmental Area and over 1,900 acres of natural beauty. Our <a class=\"richtext-link\" href=\"/floor-plans\">Owings Mills apartments</a> offer breathtaking views complemented by unmatched onsite amenities. Get a healthy workout in our state of the art fitness room or yoga room, get your grill on poolside, or shoot a game of pool in our clubroom.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applyctabanner.headline": {
    "overrideType": "VALUE",
    "customValue": "<p>APARTMENT HOMES - AVAILABLE NOW</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At the View at Mill Run, our <a class=\"richtext-link\" href=\"/neighborhood\">Owings Mills, MD</a> apartments have everything you could desire, offering open layouts with 9' ceilings, walk-in closets and full-size washer and dryers in each home. Our floor plans provide ample space, designer finishes, and fully applianced kitchens making entertaining a breeze. If fresh air is what you want, you'll enjoy breathtaking views overlooking Soldier's Delight from your private patio. The View at Mill Run, a place you're proud to call home. Make sure to go online to either schedule your personal tour or start your application. We are excited to see you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>View photos of The View at Mill Run and get introduced to a community that encompasses natural beauty and suburban living in Owings Mills, MD. Our <a class=\"richtext-link\" href=\"/floor-plans\">apartments for rent</a> in Owings Mills, MD offer a variety of spacious floor plans, top-notch amenities like our resort-style pool and the outdoor patios, and a perfect location near Soldier's Delight. Our clubhouse, sparkling pool and modern finishes contribute to an unparalleled living experience. Schedule a tour of our community today and be impressed by The View at Mill Run. You can also go online to start your application after you view the photos!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "incomerestrictedcontent.eligibility_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Eligibility for income-restricted apartment homes at The View at Mill Run depends on your household size and total gross annual household income. Income limits and maximum rents are updated from time to time, so please <a href=\"/contact-us\">contact our leasing office</a> for the current figures for our one- and two-bedroom homes. Housing Choice Voucher holders are welcome to apply. Households applying with a voucher do not have to meet a minimum income requirement.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.important_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Some apartment homes may offer accessibility features. If you need a reasonable accommodation or an accessible home, please ask our leasing team about what is available.</p><p>Residents pay for any utilities not included in rent, including electric, natural gas, and water/sewer, plus phone, cable, and internet if they choose to have them. Trash removal is already included in the base rent.</p>",
    "mappedField": null
  },
  "incomerestrictedcontent.utilities_body": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Electric and natural gas are billed through third-party providers, and water/sewer is billed based on usage. Where your program applies one, a utility allowance for these services is factored into your income-restricted rent calculation.</p>",
    "mappedField": null
  },
  "lifestyleintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">There's more to love at The View at Mill Run; The View at Mill Run overlooks Soldier's Delight Natural Environmental Area and over 1,900 acres of natural beauty. Our </span><a class=\"richtext-link\" href=\"/floor-plans\"><u>Owings Mills apartments</u></a><span style=\"font-size: 16px;\"> offer breathtaking views complemented by unmatched onsite amenities. Get a healthy workout in our state of the art fitness room or yoga room, get your grill on poolside, or shoot a game of pool in our clubroom.</span></p>",
    "generatedValue": "<p>Your <a href=\"/amenities\">apartment-living experience</a> is our top priority at The View at Mill Run. Inside your home, enjoy a full-size washer and dryer, 9-foot ceilings, and a fully applianced kitchen, with granite countertops and sunrooms available in select homes. Step outside to lounge by the swimming pool, fire up the California kitchen on our shuffleboard patio, or recharge in the 24-hour fitness center and yoga room. Deliveries are simple with our Amazon Hub package system, and our pet-friendly community welcomes your four-legged family too. At our apartments for rent in Owings Mills, everything you need is right at home.</p>",
    "mappedField": null
  },
  "neighborhooddiscover.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": "<p>Life at The View at Mill Run puts the best of Owings Mills, MD within easy reach. Commuting is simple with the Owings Mills Metro Station and quick access to I-795, I-83, and I-695. Stock up at Wegmans or Costco, grab brunch at Eggspectation, or settle in for dinner at The Tillery before catching a movie at AMC. When you want fresh air, head to Northwest Regional Park or hike the trails of Soldiers Delight, a natural area of more than 1,900 acres with beautiful views. Ready to see what's nearby? Explore our <a href=\"/interactive-map\">interactive map</a> to find your new local favorites.</p>",
    "mappedField": "property_home_neighborhood_blurb"
  },
  "retailshops.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Shopping &amp; Dining Near The View at Mill Run</p>",
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nothing helps you to imagine the possibilities for a <a class=\"richtext-link\" href=\"/floor-plans\">new apartment home</a> quite like a virtual tour. Take a look around our apartments in Owings Mills, MD - we know you'll love it here!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactinfocards.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "footer.address": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_google_place_url"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Tour"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Search Apartments"
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "galleryslider.images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "floorplanslist.apartment_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_dcbf6781-2182-4560-8a45-4fa9b6cdfd10",
      "custom_9e6f9bfd-047f-4ff9-8155-5e4c3206f8c3",
      "custom_3ddb5d4a-de01-4f23-a94f-05a5a406c1b5",
      "custom_dea1a795-6833-44c0-b2e4-46e522b30026",
      "custom_3019e97d-fdbd-4a7a-aff5-e3c29e32e4a4",
      "custom_5b868d52-8855-4da1-bc80-08b549512608",
      "custom_30d446fa-7ca7-4afd-b6ad-ad2c36a8b8c3",
      "custom_396ac4ce-9228-444e-bcf0-fd7d0e4149e5",
      "custom_48867044-f128-4bbe-8f4d-fca9b5430025"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
